import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/models/model';
import { ApiService } from 'src/app/services/api.services';
import { MatDivider } from '@angular/material/list';

@Component({
	selector: 'app-billing-confirm-contract',
	templateUrl: './billing-confirm-contract.component.html',
	styleUrls: ['./billing-confirm-contract.component.scss'],
	imports: [MatDivider],
})
export class BillingConfirmContractComponent implements OnInit {
	@Input() companyName: string = '';
	activeCompanyId: string | undefined = '';

	constructor(
		private readonly apiService: ApiService,
		private readonly router: Router
	) {}

	ngOnInit(): void {
		this.setActiveCompanyId();
	}

	onAddButtonClick(): void {
		this.router.navigateByUrl('/add-billingcontract', {
			state: { companyId: this.activeCompanyId },
		});
	}

	onReturnToCustomerListClick(): void {
		this.router.navigateByUrl('/billing');
	}

	async setActiveCompanyId(): Promise<void> {
		const userProfile: UserProfile = await this.apiService.getUserProfile();
		this.activeCompanyId = userProfile?.activeRoleDetails?.company?.id;
	}

	getApiService() {
		return this.apiService;
	}
}
